export enum DocumentStates {
  SIGNED = 1,
  NOTSIGNED = 2,
  TOBEREVIEWED = 3,
  NOTCOMPLIANT = 4,
  APPROVED = 5,
}
